module.exports = __webpack_public_path__ + "img/interest.e2dbd674.png";